import ApiSIT from '@/api/apiErp/apiErpSIT';

export default {
  setOrphansLoading({ commit }, value) {
    commit('setOrphanSheetsLoading', value);
  },

  async getOrphans(context, { start, size, search }) {
    try {
      const destinationId = context.rootState.app.destination.id;
      let sheetData = [];
      context.commit('setOrphanSheetsLoading', true);
      const sheetsResponse = await ApiSIT.getOrphanSheets(destinationId, start, size, search);
      if (sheetsResponse.status === 200) {
        sheetData = sheetsResponse.data;
      }
      if (sheetData) {
        context.commit('setOrphanSheets', sheetData.values);
        context.commit('setOrphanSheetsMeta', { count: sheetData.count });
        context.commit('setOrphanSheetsLoading', false);
      }
    } catch (e) {
      throw e;
    }
  },

  async getOrphanSheets(context) {
    try {
      context.commit('setOrphanSheetsLoading', true);
      let sheets = [];
      const destinationId = context.rootState.app.destination.id;
      const sheetsResponse = await ApiSIT.getOrphanSheets(destinationId);
      if (sheetsResponse.status === 200) {
        sheets = sheetsResponse.data;
      }
      if (sheets) {
        context.commit('setOrphanSheets', sheets.values);
        context.commit('setOrphanSheetsLoading', false);
      }
    } catch (e) {
      throw e;
    }
  },
};
